import React, { useState, useContext, useEffect } from 'react';
import {
  Lock,
  Mail,
  Eye,
  EyeOff,
  AlertCircle,
  LogIn,
  Shield, Users, BarChart2, Settings
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import AppContext from '../../../../context/AppContext';

import '../../../../assets/css/screens/admin/auth/AdminLogin.css';
import axios from 'axios';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
const {
  baseUrl,
  setAuthToken,
  RegExpChecker
} = useContext(AppContext);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');


const handleLogin = (e) => {
   e.preventDefault();

  if (!validateLogin()) {
    return;
  }

  setErrors({});

  setIsLoading(true);

  const formData = new FormData();
  formData.append("email", email);
  formData.append("password", password);
  formData.append("type","login");

  axios.post(`${baseUrl}/subadmin/login`, formData)
    .then(response => {
      setIsLoading(false);

      console.log("FULL RESPONSE:", response.data);

      const token = response.data.token;

      if (token) {
      
  localStorage.setItem("authToken", response.data.token);
localStorage.setItem("email", email);

// hashed password
localStorage.setItem(
    "password",
    response.data.subadmin.password
);
localStorage.setItem(
    "subadminId",
    response.data.subadmin.id
);

        setAuthToken(token);

        console.log("TOKEN SAVED:", localStorage.getItem("authToken")); // 👈 DEBUG

        navigate("/admin-home");
      }
    })
.catch(err => {
  setIsLoading(false);

  const message = err.response?.data?.message;

  if (message === "Incorrect password.") {
    setErrors({
      password: message
    });
  } else {
    setErrors({
      email: message
    });
  }

  console.log(err.response?.data);
});
};
  const [errors, setErrors] = useState({});



  const validateLogin = () => {
    const newErrors = {};

    if (!email) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = 'Email is invalid';
    }

    if (!password) {
      newErrors.password = 'Password is required';
    } else if (password.length < 6) {
      newErrors.password = 'Password must be at least 6 characters';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // const handleLoginSubmit = (e) => {
  //   e.preventDefault();

  //   if (validateLogin()) {
  //     setIsLoading(true);
  //     setTimeout(() => {
  //       setIsLoading(false);
  //       navigate('/admin-home');
  //     }, 1500);
  //   }
  // };
useEffect(()=>{

    const email = localStorage.getItem("email");
    const password = localStorage.getItem("password");

    if(email && password){
        adminAutoLogin(email,password);
    }

},[]);

const adminAutoLogin = (email, password) => {

    setIsLoading(true);   // 👈 Add this

    const formData = new FormData();

    formData.append("email", email);
    formData.append("password", password);
    formData.append("type", "autologin");

    axios.post(`${baseUrl}/subadmin/login`, formData)

    .then(res => {

        setIsLoading(false);   // 👈 Add this

        localStorage.setItem("authToken", res.data.token);
        localStorage.setItem(
    "subadminId",
    res.data.subadmin.id
);

        setAuthToken(res.data.token);

        navigate("/admin-home");

    })

    .catch(() => {

        setIsLoading(false);   // 👈 Add this

        localStorage.removeItem("authToken");
        localStorage.removeItem("email");
        localStorage.removeItem("password");

    });

}
  return (
    <div className="admin-auth-page">
      <div className="auth-container">
        
        <div className="auth-form-section">
          <div className="form-wrapper">

            {/* Header */}
            <div className="form-header">
              {/* <div className="header-icon"> */}
                {/* <Lock size={32} /> */}
              {/* </div> */}
              <h2>Admin Login</h2>
              <p>Login to access your admin dashboard</p>
            </div>

            {/* Login Form */}
            <form className="auth-form" onSubmit={handleLogin}>

              {/* Email */}
              <div className="form-group">
                <label> <Mail size={18} />Email Address</label>
                {/* <div className={`input-wrapper ${errors.email ? 'error' : ''}`}> */}

              <input
  type="email"
  name="email"
  placeholder="admin@gharpar.com"
  value={email}
  onChange={e => setEmail(e.target.value)}
  className={errors.email || errors.server ? "input-error" : ""}
/>
                {/* </div> */}
               {errors.email && (
  <span className="error-message">
    <AlertCircle size={14} />
    {errors.email}
  </span>
)}
{errors.server && (
  <span className="error-message">
    <AlertCircle size={14} />
    {errors.server}
  </span>
)}
              </div>

              {/* Password */}
            {/* Password */}
<div className="form-group">
  <label>
    <Lock size={18} /> Password
  </label>

  <div className={`input-wrapper ${errors.password ? "error" : ""}`}>
    <input
      type={showPassword ? "text" : "password"}
      name="password"
      placeholder="Enter your password"
      value={password}
      onChange={(e) => setPassword(e.target.value)}
      className={errors.password ? "input-error" : ""}
    />

    <button
      type="button"
      className="toggle-password"
      onClick={() => setShowPassword(!showPassword)}
    >
      {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
    </button>
  </div>

  {errors.password && (
    <span className="error-message">
      <AlertCircle size={14} />
      {errors.password}
    </span>
  )}
</div>

              {/* Submit */}
    <button
  type="submit"
  className="submit-btn"
  disabled={isLoading}
>
  {isLoading ? (
    <>
      <span className="loader"></span>
      Please wait...
    </>
  ) : (
    "Login"
  )}
</button>

            </form>
          </div>
        </div>
        <div className="auth-info-panel">
 
  {/* Logo */}
  <div className="auth-info-panel__logo">
    <div className="auth-info-panel__logo-icon">
      <Shield size={22}/>
    </div>
    <span className="auth-info-panel__logo-text">Picks4Tips Admin</span>
  </div>
 
  {/* Content */}
  <div className="auth-info-panel__content">
    <h2 className="auth-info-panel__title">
      Manage Everything<br/>From One Place
    </h2>
    <p className="auth-info-panel__desc">
      Picks4Tips Admin gives you full control over your platform — manage workers,
      customers, jobs, disputes, and subscriptions all in one powerful dashboard.
    </p>
 
    {/* Features */}
    <div className="auth-info-panel__features">
      <div className="auth-info-panel__feature">
        <div className="auth-info-panel__feature-icon">
          <Users size={18}/>
        </div>
        <div className="auth-info-panel__feature-text">
          <span className="auth-info-panel__feature-title">User Management</span>
          <span className="auth-info-panel__feature-sub">Manage customers, workers</span>
        </div>
      </div>
 
      <div className="auth-info-panel__feature">
        <div className="auth-info-panel__feature-icon">
          <BarChart2 size={18}/>
        </div>
        <div className="auth-info-panel__feature-text">
          <span className="auth-info-panel__feature-title">Real-time Analytics</span>
          <span className="auth-info-panel__feature-sub">Track jobs, revenue & platform growth</span>
        </div>
      </div>
 
      <div className="auth-info-panel__feature">
        <div className="auth-info-panel__feature-icon">
          <Shield size={18}/>
        </div>
        <div className="auth-info-panel__feature-text">
          <span className="auth-info-panel__feature-title">Dispute Resolution</span>
          <span className="auth-info-panel__feature-sub">Review & resolve customer disputes fast</span>
        </div>
      </div>
 
      <div className="auth-info-panel__feature">
        <div className="auth-info-panel__feature-icon">
          <Settings size={18}/>
        </div>
        <div className="auth-info-panel__feature-text">
          <span className="auth-info-panel__feature-title">Full Control</span>
          <span className="auth-info-panel__feature-sub">Configure subscriptions, categories & more</span>
        </div>
      </div>
    </div>
  </div>
 
  {/* Footer note */}
  <p className="auth-info-panel__note">Secured & encrypted admin access</p>
 
</div>
        
      </div>
    </div>
  );
};

export default AdminLogin;
